import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PrimeContractorComponent } from './prime-contractor.component';
import { protectGuard } from '../shared/guards/protect.guard';
import { ViewSiteComponent } from './sites/view-site/view-site.component';
import { SitesComponent } from './sites/sites.component';
import { JobsComponent } from './jobs/jobs.component';
import { PreviewReportComponent } from './jobs/preview-report/preview-report.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { PreviewIncidentReportComponent } from './incidents/preview-incident-report/preview-incident-report.component';

const routes: Routes = [
  {
    path: '',
    component: PrimeContractorComponent,
    canActivate: [protectGuard],
    canActivateChild: [protectGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'sites',
        component: SitesComponent,
      },
      {
        path: 'view-site',
        component: ViewSiteComponent,
      },
      {
        path: 'jobs',
        component: JobsComponent,
      },
      {
        path: 'preview-docket',
        component: PreviewReportComponent,
      },
      {
        path: 'incidents',
        component: IncidentsComponent,
      },
      {
        path: 'preview-incident',
        component: PreviewIncidentReportComponent,
      },
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrimeContractorRoutingModule {}
